import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import CreateBot from 'views/plans/CreateBot';
// import PaymentResponse from 'views/plans/PlanCheckout/paymentresponse';
import PlanSuccess from 'views/plans/PlanCheckout/SuccessPlan';
import PlanCancelled from 'views/plans/PlanCheckout/CancelledPlan';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));
const ShowPlans = Loadable(lazy(() => import('views/plans/showplans')));
const ChangePassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ChangePassword')));
const ViewProfile = Loadable(lazy(() => import('views/Profile/ViewProfile')));
const BotStore = Loadable(lazy(() => import('views/plans/botStore')));
const BotConfig = Loadable(lazy(() => import('views/plans/botConfig')));
const CardDetails = Loadable(lazy(() => import('views/plans/CardDetails')));
const PlanCheckout = Loadable(lazy(() => import('views/plans/PlanCheckout')));




// sample page routing

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/dashboard',
      element: <DashboardDefault />
    },
    {
      path: '/showplan',
      element: <ShowPlans />
    },
    {
      path: '/botStore',
      element: <BotStore />
    },
    {
      path: '/botconfig',
      element: <BotConfig />
    },
    {
      path: '/changepassword',
      element: <ChangePassword />
    },
    {
      path: '/viewprofile',
      element: <ViewProfile />
    },
    {
      path: '/carddetails',
      element: <CardDetails />
    },
    {
      path: '/plancheckout',
      element: <PlanCheckout />
    },
    {
      path: '/createbot',
      element: <CreateBot />
    },
    {
      path: '/successplan',
      element: <PlanSuccess />
    },
    {
      path: '/cancelledplan',
      element: <PlanCancelled />
    },
    {
      path: 'utils',
      children: [
        {
          path: 'util-typography',
          element: <UtilsTypography />
        }
      ]
    },
    {
      path: 'utils',
      children: [
        {
          path: 'util-color',
          element: <UtilsColor />
        }
      ]
    },
    {
      path: 'utils',
      children: [
        {
          path: 'util-shadow',
          element: <UtilsShadow />
        }
      ]
    },
    {
      path: 'icons',
      children: [
        {
          path: 'tabler-icons',
          element: <UtilsTablerIcons />
        }
      ]
    },
    {
      path: 'icons',
      children: [
        {
          path: 'material-icons',
          element: <UtilsMaterialIcons />
        }
      ]
    },
   
  ]
};

export default MainRoutes;
